import { Component, Input, Output, EventEmitter, inject } from '@angular/core';
import { ColorUtilsService } from '@app/core/services/color-utils.service';

@Component({
    selector: 'topo-color-count-pill',
    templateUrl: './color-count-pill.component.html',
    styleUrls: ['./color-count-pill.component.scss'],
    standalone: false
})
export class ColorCountPillComponent {
  @Input() colorCode: string;
  @Input() count: number;
  @Input() isFolder = false;
  @Input() clickable = false;
  @Output() actionClick = new EventEmitter<any>();

  private colorUtils = inject(ColorUtilsService);

  get textColorClass(): string {
    if (this.isFolder) {
      return 'grey';
    }
    if (!this.colorCode) {
      return 'light';
    }

    return this.colorUtils.isColorLightOrDark(this.colorCode);
  }

  onClick(): void {
    this.actionClick.emit();
  }
}
